<template>
  <div id="PageLanding">
    <SectionHero />
    <SectionTrust />
    <SectionSupport />
    <SectionCertifications />
    <SectionPlatform />
    <SectionRisk />
    <SectionCompliance />
    <SectionPipeline />
    <SectionXBRL />
    <SectionFeatureList />
    <SectionReviews />
  </div>
</template>

<script setup lang="ts">
import SectionHero from './sections/SectionHero.vue'
import SectionXBRL from './sections/SectionXBRL.vue'
import SectionFeatureList from './sections/SectionFeatureList.vue'
import SectionSupport from './sections/SectionSupport.vue'
import SectionCertifications from './sections/SectionCertifications.vue'
import SectionPlatform from './sections/SectionPlatform.vue'
import SectionRisk from './sections/SectionRisk.vue'
import SectionPipeline from './sections/SectionPipeline.vue'
import SectionTrust from '@/views/components/sections/SectionTrust.vue'
import SectionCompliance from '@/views/components/sections/SectionCompliance.vue'
import SectionReviews from '@/views/components/sections/SectionReviews.vue'
import { useSeo, getWebsiteStructuredData, getSoftwareStructuredData } from '@/composables/useSeo'
import { getSeoConfig } from '@/config/seo'

// SEO Configuration
useSeo(getSeoConfig('landing'), [getWebsiteStructuredData(), getSoftwareStructuredData()])
</script>

<style lang="scss" scoped>
#PageLanding {
  min-height: 100vh;
}
</style>
